import React, { useEffect } from 'react'
import { Control, Controller, useForm, useFormContext } from 'react-hook-form'
import {
	Stack,
	Text,
	TextInput,
	TextArea,
	Tiles,
	Tile,
	useBreakpoints,
	Box,
} from '../../../components/DesignSystem'
import Formatter from '../../../helpers/Formatter'
import { GiftCardType } from '../types'
import type { GiftCardFormData } from '../index'

interface RecipientFormProps {
	control: Control<GiftCardFormData>
}

export default function RecipientForm({ control }: RecipientFormProps) {
	return (
		<Stack gap="md">
			<Text
				weight="strong"
				align={{
					mobile: 'left',
					tablet: 'left',
					desktop: 'left',
				}}
			>
				Where should we send the gift card?
			</Text>
			<Tiles columns={{ mobile: 1, tablet: 2, desktop: 2 }} space="md">
				<Tile>
					<TextInput
						placeholder="Your Name"
						control={control}
						name="senderName"
						keyboardType="default"
						width="full"
					/>
				</Tile>

				<Tile>
					<TextInput
						placeholder="Recipient Name"
						control={control}
						name="recipientName"
						keyboardType="default"
						width="full"
					/>
				</Tile>

				<Tile>
					<TextInput
						placeholder="Recipient Email"
						control={control}
						name="recipientEmail"
						keyboardType="email-address"
						width="full"
					/>
				</Tile>

				<Tile>
					<Controller
						control={control}
						name="recipientPhone"
						render={({ field, fieldState: { error } }) => (
							<TextInput
								placeholder="Recipient Phone #"
								value={field.value || ''}
								onChange={e => {
									const numericValue = e.nativeEvent.text.replace(/[^0-9]/g, '')
									const formatted = Formatter.formatPhoneNumber(numericValue)
									field.onChange(formatted)
								}}
								keyboardType="phone-pad"
								maxLength={14}
								error={error?.message}
								width="full"
							/>
						)}
					/>
				</Tile>

				<Tile width={{ mobile: 1, tablet: 2, desktop: 2 }}>
					<TextArea
						placeholder="Message (optional)"
						control={control}
						name="customMessage"
						width="full"
						rows={4}
					/>
				</Tile>
			</Tiles>
		</Stack>
	)
}
